// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "dil_uuid",
                Decco.stringToJson(v.dil_uuid)
              ],
              [
                "timestamp",
                Decco.intToJson(v.timestamp)
              ]
            ]);
}

export {
  t_encode ,
}
/* No side effect */
